import * as React from 'react';
import { HTMLAttributes } from 'react';
import cn from 'classnames';

export interface Props extends HTMLAttributes<HTMLLIElement> {}

export default function ListItem({ className, children, ...props }: Props) {
  return (
    <li className={cn('mos-list__item', className)} {...props}>
      {children}
    </li>
  );
}
